import Config from "../Config";
import LocalData from "../helpers/local-data";

const initialState = {
  type: null,
  loading: false,
  dinein: {},
  category: null,
  isAdmin: LocalData.get(Config.LOCAL_DATA_KEYS.IS_ADMIN) === 'true',
  hasPermissions: LocalData.get(Config.LOCAL_DATA_KEYS.HAS_PERMISSIONS) === 'true',
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case Config.REDUCER_TYPES.SET_LOADING:
      return {
        ...state,
        ...{ type: action.type, loading: action.payload },
      };
    case Config.REDUCER_TYPES.SET_DINEIN:
      return {
        ...state,
        ...{ type: action.type, dinein: action.payload },
      };
    case Config.REDUCER_TYPES.SET_CATEGORY:
      return {
        ...state,
        ...{ type: action.type, category: action.payload },
      };
    case Config.REDUCER_TYPES.SET_IS_ADMIN:
      return {
        ...state,
        ...{ type: action.type, isAdmin: action.payload },
      };
    case Config.REDUCER_TYPES.SET_HAS_PERMISSIONS:
      return {
        ...state,
        ...{ type: action.type, hasPermissions: action.payload },
      };
    default:
      return state;
  }
};

export default Reducer;
